import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../../../services/prod/i18n.service'
import { ProducerItemType } from '../../../../types/producer.type'

@Component({
  selector: 'bmcore-producer-item',
  templateUrl: './bmcore-producer-item.component.html',
  styleUrls: ['./bmcore-producer-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreProducerItemComponent implements OnInit {
  @Input() producer: ProducerItemType

  lg: LgType

  pluralizedBeatsCount: string

  constructor(private i18nService: I18nService) {
    this.lg = this.i18nService.getLanguageForPage()
  }

  ngOnInit(): void {
    this.pluralizeBeatsCount()
  }

  pluralizeBeatsCount() {
    this.pluralizedBeatsCount = this.lg.pluralizeBeats({
      count: this.producer.beatsCount,
      isTotalBeatsCount: false
    })
  }
}
